import { FC, useState, ChangeEvent, KeyboardEvent, useEffect } from "react";
import colors from "../config/Colors.config";
import { Col, Row, Label, FormGroup, Input, InputGroup, InputGroupText, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Login from "../interfaces/Login.interface";
import { PermIdentityOutlined, LockOutline, LockOpen, Close, WarningAmberOutlined, CloseFullscreen } from "@mui/icons-material";
import { Slide } from "react-awesome-reveal";
import ComponentsTool from "../tools/Components.tool";
import { IconButton } from "@mui/material";
import TiempoTool from "../tools/Tiempo.tool";
import { PulseLoader } from "react-spinners";
import Response from "../interfaces/Response.interface";
import UsuarioService from "../services/Usuario.service";
import Usuario from "../interfaces/Usuario.interface";
import Cookies from 'universal-cookie';


import imgFondo from "../assets/img/fondo.png";
import imgLogo2 from "../assets/img/logo2.png";
import CookieConfig from "../config/Cookie.config";
import DeviceConfig from "../config/Device.config";
import Device from "../interfaces/Device.interface";

const LoginView: FC = () => {

    const cookies: Cookies = new Cookies(CookieConfig.param, CookieConfig.object);

    const [login, setLogin] = useState<Login>({ username: "", password: "" });

    const [indexLogin, setIndexLogin] = useState<number>(0);
    const [labelTitulo, setLabelTitulo] = useState<string>("");
    const [labelTexto, setLabelTexto] = useState<string>("");
    const [colorLabel,] = useState<string>("#000000");

    const [visible, setVisible] = useState<boolean>(false);
    const [openModalLogin, setOpenModalLogin] = useState<boolean>(false);

    const [device, setDevice] = useState<Device>(DeviceConfig.data());

    useEffect(() => {
        ComponentsTool.focus("login.username");
        setDevice(DeviceConfig.data())
    }, []);

    const cambioLogin = (name: string, value: string | number) => {
        setLogin((prev: Login) => ({ ...prev, [name]: value }));
    };

    const limpiar = (): void => {
        setLogin({ username: "", password: "" });
        ComponentsTool.focus("login.username")
    };

    const usuarioLogin = async (): Promise<void> => {

        setIndexLogin(1);

        setLabelTitulo("");
        setLabelTexto("");

        if (login.username.length === 0 || login.password.length === 0) {
            setOpenModalLogin(true);
            setLabelTitulo("¡Atencion!");
            setLabelTexto("No has espesificado el nombre de usuario y/o la contraseña");
        } else {

            // await TiempoTool.sleep(2);
            const response: Response = await UsuarioService.login(login);                 
            console.log(response) 
            if (response.error === false) {
                const usuario: Usuario = response.data.value;
                if (usuario.IdUsuario === 0) {
                    setOpenModalLogin(true);
                    setLabelTitulo("Acceso denegado");
                    setLabelTexto("Nombre de usuario o contraseñas no validos");
                } else {                    
                    cookies.set('usuario', usuario);
                    window.location.href = "/dashboard";
                }
            } else {
                setLabelTitulo("Error");
                setLabelTexto(JSON.stringify(response.data.message, null, 2));
                setOpenModalLogin(true);
            }
        }
        setIndexLogin(0);

    }

    return (
        <>
            {
                device.isDesktop ?
                    <section
                        id="section"
                        style={{ height: "100vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundImage: `url(${imgFondo})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", }}
                    // style={{
                    //     height: "100vh",
                    //     width: "100%",
                    //     display: "flex",
                    //     justifyContent: "center",
                    //     alignItems: "center",
                    //     backgroundImage: `
                    //         linear-gradient(rgba(15, 60, 136, 0.85), rgba(30, 111, 217, 0.85)),
                    //         url(${imgFondo})
                    //     `,
                    //     backgroundSize: "cover",
                    //     backgroundPosition: "center",
                    //     backgroundRepeat: "no-repeat",
                    // }}
                    >

                        <Row style={{ width: "90%", minWidth: "90%", maxWidth: "90%", height: "90vh", backgroundColor: "transparent", }} >


                            <Col style={{ minWidth: "55%", maxWidth: "55%", width: "55%", color: colors.blanco, paddingTop: "2rem", }} >
                                <Slide>
                                    <Row style={{ marginTop: "25vh", marginRight: "1%", marginLeft: "1%" }} >
                                        <Col>
                                            <Label style={{ fontWeight: "bold", fontSize: "2rem" }}>
                                                Sistema de Solicitud de Crédito
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginRight: "1%", marginLeft: "1%" }} >
                                        <Col>
                                            <p style={{ textAlign: "justify", marginTop: "1rem" }}>
                                                El sistema de Tzedaká permite a las familias solicitar créditos de manera sencilla y segura, respaldados por principios de justicia, confianza y solidaridad, ofreciendo oportunidades para alcanzar sus metas financieras y asegurar la estabilidad de sus seres queridos.
                                            </p>
                                        </Col>
                                    </Row>
                                </Slide>
                            </Col>

                            <Col style={{ minWidth: "40%", maxWidth: "40%", width: "40%", height: "100%", backgroundColor: colors.blanco, borderRadius: 40, marginRight: "5%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "stretch", padding: "1rem", }}                >
                                <Slide direction="up" >
                                    <Row style={{ marginRight: 5, marginLeft: 5, marginTop: 0 }} >
                                        <Col  >
                                            <center>
                                                <img style={{ height: "10rem" }} src={imgLogo2} alt="No data" />
                                            </center>
                                        </Col>
                                    </Row>

                                    <Row style={{ marginRight: 5, marginLeft: 5, marginTop: 20 }} >
                                        <Col style={{ textAlign: "center" }} >
                                            <Label style={{ fontWeight: "bold", fontSize: 24, color: colors.secundario }} >
                                                Inicio de Sesión
                                            </Label>
                                            <br />
                                            <small style={{ fontSize: 13 }} >
                                                Bienvenido de nuevo, ingresa tus credenciales para continuar
                                            </small>
                                        </Col>
                                    </Row>

                                    <Row style={{ marginRight: 5, marginLeft: 5, marginTop: 20 }} >
                                        <Col>
                                            <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                                <InputGroup >
                                                    <InputGroupText
                                                        style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0 }}
                                                    >
                                                        <PermIdentityOutlined />
                                                    </InputGroupText>
                                                    <Input
                                                        id="login.username"
                                                        name="username"
                                                        type="text"
                                                        placeholder=" "
                                                        value={login.username}
                                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                        onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                            cambioLogin(name, value);
                                                        }}
                                                        onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {
                                                            if (login.password.length === 0) {
                                                                if (key === "Enter") {
                                                                    ComponentsTool.focus("login.password");
                                                                }
                                                            } else {
                                                                if (key === "Enter") {
                                                                    if (login.password.length > 0 && login.username.length > 0) {
                                                                        usuarioLogin();
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                        autoComplete="off"
                                                    />
                                                    <Label style={{ marginLeft: 40 }} >Ingresa tu usuario</Label>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row style={{ marginRight: 5, marginLeft: 5, marginTop: 20 }} >
                                        <Col>
                                            <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                                <InputGroup >
                                                    <InputGroupText
                                                        style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                                        onClick={() => setVisible(!visible)}
                                                    >

                                                        {visible ? <LockOpen /> : <LockOutline />}
                                                    </InputGroupText>
                                                    <Input
                                                        id="login.password"
                                                        name="password"
                                                        type={visible ? "text" : "password"}
                                                        placeholder=" "
                                                        value={login.password}
                                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                        onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                            cambioLogin(name, value);
                                                        }}
                                                        onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {
                                                            if (login.username.length === 0) {
                                                                if (key === "Enter") {
                                                                    ComponentsTool.focus("login.username");
                                                                }
                                                            } else {
                                                                if (key === "Enter") {
                                                                    if (login.password.length > 0 && login.username.length > 0) {
                                                                        usuarioLogin();
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Label style={{ marginLeft: 40 }} >Ingresa tu contraseña</Label>
                                                    <InputGroupText
                                                        style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                                        onClick={() => setVisible(!visible)}
                                                    >
                                                        {visible ? "Ocultar" : "Mostrar"}
                                                    </InputGroupText>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row style={{ marginRight: 5, marginLeft: 5, marginTop: 20 }} >
                                        <Col>
                                            <Button
                                                id="btn-cancel"
                                                className="button-click-effect"
                                                style={{ width: "100%", fontWeight: "bold", backgroundColor: colors.blanco, borderColor: colors.secundario, boxShadow: "none", color: colors.secundario }}
                                                onClick={() => limpiar()}

                                            >
                                                Cancelar
                                            </Button>
                                        </Col>
                                        <Col>
                                            <Button
                                                className="button-click-effect"
                                                style={{ width: "100%", boxShadow: "none", backgroundColor: colors.secundario, fontWeight: "bold" }}
                                                onClick={() => usuarioLogin()}
                                            >
                                                {indexLogin === 1 && <PulseLoader color="#efefef" loading size={7} />}
                                                {indexLogin === 0 && " Iniciar Sesión"}

                                            </Button>
                                        </Col>
                                    </Row>
                                </Slide>
                            </Col>

                        </Row>

                    </section>
                    :
                    <section id="section" style={{ height: "100vh", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", }} >
                        <Row style={{ width: "96%", marginRight: "2%", marginLeft: "2%" }} >
                            <Col  >
                                <center>
                                    <img style={{ height: "10rem" }} src={imgLogo2} alt="No data" />
                                </center>
                            </Col>
                        </Row>
                        <Row style={{ width: "96%", marginRight: "2%", marginLeft: "2%", marginTop: 20 }} >
                            <Col>
                                <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                    <InputGroup >
                                        <InputGroupText
                                            style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0 }}
                                        >
                                            <PermIdentityOutlined />
                                        </InputGroupText>
                                        <Input
                                            id="login.username"
                                            name="username"
                                            type="text"
                                            placeholder=" "
                                            value={login.username}
                                            style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                            onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                cambioLogin(name, value);
                                            }}
                                            onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {
                                                if (login.password.length === 0) {
                                                    if (key === "Enter") {
                                                        ComponentsTool.focus("login.password");
                                                    }
                                                } else {
                                                    if (key === "Enter") {
                                                        if (login.password.length > 0 && login.username.length > 0) {
                                                            usuarioLogin();
                                                        }
                                                    }
                                                }
                                            }}
                                            autoComplete="off"
                                        />
                                        <Label style={{ marginLeft: 40 }} >Nombre de Usuario</Label>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row style={{ width: "96%", marginRight: "2%", marginLeft: "2%", marginTop: 20 }} >
                            <Col>
                                <FormGroup className={`google-input ${true ? "move-left" : ""}`}>
                                    <InputGroup >
                                        <InputGroupText
                                            style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                            onClick={() => setVisible(!visible)}
                                        >

                                            {visible ? <LockOpen /> : <LockOutline />}
                                        </InputGroupText>
                                        <Input
                                            id="login.password"
                                            name="password"
                                            type={visible ? "text" : "password"}
                                            placeholder=" "
                                            value={login.password}
                                            style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                            onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                cambioLogin(name, value);
                                            }}
                                            onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {
                                                if (login.username.length === 0) {
                                                    if (key === "Enter") {
                                                        ComponentsTool.focus("login.username");
                                                    }
                                                } else {
                                                    if (key === "Enter") {
                                                        if (login.password.length > 0 && login.username.length > 0) {
                                                            usuarioLogin();
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                        <Label style={{ marginLeft: 40 }} >Contraseña</Label>
                                        <InputGroupText
                                            style={{ color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0, cursor: "pointer" }}
                                            onClick={() => setVisible(!visible)}
                                        >
                                            {visible ? "Ocultar" : "Mostrar"}
                                        </InputGroupText>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row style={{ width: "96%", marginRight: "2%", marginLeft: "2%", marginTop: 20 }} >
                            <Button
                                className="button-click-effect"
                                style={{ width: "100%", boxShadow: "none", backgroundColor: colors.secundario, fontWeight: "bold", height: 50, borderRadius: 20 }}
                                onClick={() => usuarioLogin()}
                            >
                                {indexLogin === 1 && <PulseLoader color="#efefef" loading size={7} />}
                                {indexLogin === 0 && " Iniciar Sesión"}

                            </Button>
                        </Row>
                        <Row style={{ width: "96%", marginRight: "2%", marginLeft: "2%", marginTop: 40 }} >
                            <Button
                                id="btn-cancel"
                                className="button-click-effect"
                                style={{ width: "100%", fontWeight: "bold", backgroundColor: colors.blanco, borderColor: colors.secundario, boxShadow: "none", color: colors.secundario, height: 50, borderRadius: 20 }}
                                onClick={() => limpiar()}

                            >
                                Cancelar
                            </Button>
                        </Row>
                    </section >
            }




            <Modal
                isOpen={openModalLogin}
                onOpened={() => {
                    TiempoTool.sleep(labelTexto.length > 300 ? 30 : 5).then(() => {
                        setOpenModalLogin(false);
                    });
                }}
                onClosed={() => {
                    TiempoTool.sleep(0.5).then(() => {
                        ComponentsTool.focus("login.username");
                    });

                }}
                centered
                size={labelTexto.length > 300 ? "xl" : "lg"}
                style={{ fontFamily: '"Fira Code", monospace' }}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => setOpenModalLogin(false)}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <WarningAmberOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    {labelTitulo}
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {/* <Row>
                        <Label style={{ fontSize: 24, color: colorLabel, }} >
                            {labelTitulo}
                        </Label>
                    </Row> */}
                    <Row>
                        <Label style={{ fontSize: 16, color: colorLabel }} >
                            {labelTexto}
                        </Label>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ boxShadow: "none", backgroundColor: colors.secundario, fontWeight: "bold", width: "auto" }}
                        onClick={() => {
                            setOpenModalLogin(false);
                        }}
                    >
                        {indexLogin === 1 && <PulseLoader color="#efefef" loading size={7} />}
                        {indexLogin === 0 && <>   <CloseFullscreen /> Cerrar </>}
                    </Button>
                </ModalFooter>
            </Modal >
        </>
    );
};

export default LoginView;
